import type { FC } from "react";

import { AlertSearchForm } from "src/app/features/Alert/components/forms/AlertSearchForm";
import type { AlertList } from "src/app/features/Alert/types/AlertList";
import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { Actions, ResourceManager } from "../../../../components/ResourceManager/ResourceManager";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { NoneOwnProps } from "../../../../core/types";
import { AlertsTable } from "../components/tables/AlertTable";

export const AlertsPage: FC<NoneOwnProps> = () => {
    const table = <AlertsTable />;
    const searchForm = <AlertSearchForm />;
    const hasAccess = canAccess(ResourceName.ALERTS, "canRead");

    return (
        <PageLayout name="alerts_page">
            {hasAccess ? (
                <>
                    <PageTitle translationKey="menu.alerts" />
                    <ResourceManager<AlertList>
                        useDataGroup
                        dataMapperKey="alertsTableData"
                        resource={ResourceName.ALERTS}
                        table={table}
                        searchForm={searchForm}
                        actions={[Actions.ADD, Actions.DELETE, Actions.EXPORT]}
                    />
                </>
            ) : (
                <NoAccessLayout />
            )}
        </PageLayout>
    );
};
